import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest, getRequest } from '../../../lib/api';
import { useContext } from 'react';
import { AuthContext } from '../../../authContext/context';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';

export default function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [initialLoading, setInitialLoading] = React.useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();


  React.useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await postRequest(`private/getSingleProduct/${id}`, {},authCtx.token);
        if (response?.status === 200) {
          reset({
            title: response?.data?.title,
          });
        } else {
        //  toast.error(response?.message || 'Product not found');
        }
      } catch (error) {
        //toast.error(error?.message || 'Failed to load product');
      } finally {
        setInitialLoading(false);
      }
    };

    fetchProduct();
  }, [id, reset, authCtx.token]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        title: data?.title,
      };

      const response = await postRequest(`private/editProduct/${id}`, payload, authCtx.token);
      if (response?.status === 200) {
        //toast.success('Product updated successfully!');
        reset();
        navigate('/products');
      } else {
       // toast.error(response?.message || 'Product update failed');
      }
    } catch (err) {
      //toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
      <div className="page-header pb-3">
        <h1 className="mt-0 mb-0">Edit Product</h1>
      </div>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Products', path: '/products' },
          { label: 'Edit Product', path: '' },
        ]}
      />

      {initialLoading ? (
        <div className="text-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="page-top-formview mb-3">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="title">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  {...register('title', { required: 'Title is required' })}
                  isInvalid={!!errors.title}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.title?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Stack direction="row" spacing={2}>
              {/* <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/products')}>
                Cancel
              </Button> */}
              <Button variant="outlined" className='red-outline-btn text-capitalize' onClick={() => navigate('/products')}>
                                         Cancel
                                        </Button>

        
              <Button variant="contained" color="error" type="submit" disabled={loading} className='red-bg red-button text-capitalize '>
                {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
              </Button>
            </Stack>
          </Form>
        </div>
      )}
    </>
  );
}
